var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 199.1 199.1",
    style: {
      enableBackground: "new 0 0 199.1 199.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4E592;}\n\t.st1{fill:#9DCEE3;}\n\t.st2{fill:#C2E5F0;}\n\t.st3{fill:#CDB966;}\n\t.st4{fill:#1B2730;}\n\t.st5{fill:#263644;}\n\t.st6{fill:#374A5E;}\n\t.st7{fill:#677685;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.5,
    cy: 99.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.2,47c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C49.9,86.9,89.9,47,139.2,47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M188.8,99.5c0-16.1-4.3-31.1-11.7-44.1C165.6,50,152.7,47,139.2,47c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C148.8,188.8,188.8,148.8,188.8,99.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.4,77c-1.8,0-3.3,1.5-3.3,3.3v39.3c0,1.8,1.5,3.3,3.3,3.3c1.8,0,3.3-1.5,3.3-3.3V80.2 C163.6,78.4,162.2,77,160.4,77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M160.4,117c-1.8,0-3.3,0.7-3.3,1.6v3.3c0,0.9,1.5,1.6,3.3,1.6c1.8,0,3.3-0.7,3.3-1.6v-3.3 C163.6,117.8,162.2,117,160.4,117z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M147.3,121.9c0.2,1.1-0.1,2.3-0.9,3.1c-8.1,8.1-25.5,12-41.8,13L78.9,96.3l12.9,3.2c1,0.3,2.1,0.4,3.2,0.4 c1,0,1.9-0.1,2.9-0.3L140,90L147.3,121.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M78.9,96.3l25.7,41.8c-36.1-4.4-26.8-39-25.9-41.8L78.9,96.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.7,138c-3.3,0.2-6.6,0.3-9.7,0.3c-18.5,0-41.7-3.5-51.4-13.2c-0.8-0.8-1.1-1.9-0.9-3l7.5-33l28.5,7.1 C77.9,99,68.5,133.6,104.7,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M96.4,99.7c-0.5,0.1-1,0.2-1.5,0.2c0,0,5.4-6.6,0-12.3l75.2-16.3l0,0c1.9,1.1,3.3,3.1,3.4,5.5 c0.1,3.2-2,6-5.1,6.7L96.4,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M93.4,99.7L78.8,96L27.9,83.3c-3-0.8-5.1-3.6-5-6.7c0.2-3.1,2.5-5.7,5.6-6.2L94,60.7c0.3,0,0.6-0.1,1-0.1 c0.3,0,0.6,0,0.9,0l72,9.8c0.8,0.1,1.6,0.4,2.3,0.8l0,0L95,87.6c5.4,5.7,0,12.3,0,12.3C94.5,99.9,93.9,99.8,93.4,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M78.9,96.3l-0.2,0c0-0.1,0-0.2,0-0.2L78.9,96.3z"
  })), /*#__PURE__*/React.createElement("g", null))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtp);
export default __webpack_public_path__ + "static/media/atp.e60ffe20b43721d1e3e4ca8d10ff37db.svg";
export { ForwardRef as ReactComponent };